import { useMutation } from "@tanstack/react-query";
import { httpClient } from "../../config";
import { IRegisterUserDataPayload } from "../types";
import { API_REGISTER_USER_DATA } from "../../common/consts/apiUrls";

interface RegisterUserDataVariables {
  userData: IRegisterUserDataPayload;
  image?: File;
}

const toRegisterUserDataFormData = ({
  userData,
  image,
}: RegisterUserDataVariables): FormData => {
  const formData = new FormData();

  formData.append("name", userData.name);
  formData.append("surname", userData.surname);
  formData.append("health_professional", String(userData.health_professional));

  if (userData.health_professional) {
    if (userData.id_profession !== undefined)
      formData.append("id_profession", String(userData.id_profession));

    if (userData.id_registration_type !== undefined) {
      formData.append(
        "id_registration_type",
        String(userData.id_registration_type),
      );
    }

    if (userData.registration_number !== undefined) {
      formData.append("registration_number", userData.registration_number);
    }

    if (userData.document_number !== undefined) {
      formData.append("document_number", userData.document_number);
    }

    if (image) {
      formData.append("image", image);
    }
  }
  return formData;
};

export default function useRegisterUserDataMutation() {
  return useMutation({
    mutationFn: async (userData: RegisterUserDataVariables) => {
      const formData = toRegisterUserDataFormData(userData);

      return await httpClient.post(API_REGISTER_USER_DATA, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
  });
}
